
import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import DevScrumRepository from '@/services/Dev-scrum';
import { AuditInterface } from '@/services/Dev-scrum/interfaces';
import ProfileRepository from '@/services/Users-profile';
import DeleteAuditDialog from "@/components/dialogs/dev-scrums/DeleteAuditDialog.vue";

@Component({
  components: { DevAudit, DeleteAuditDialog  },
  inject: [
    'devScrumRepository',
    'profileRepository',
  ],
})
export default class DevAudit extends Vue {
  private loading: boolean = true;
  private readonly devScrumRepository: DevScrumRepository;
  private profileRepository: ProfileRepository;
  private audits: AuditInterface[] = [];
  private deleteAuditDialog: string = '';
  private deleteAuditForDialog: AuditInterface | undefined = undefined;

  private headers: DataTableHeader[] = [
    { text: 'Date', value: 'date' },
    { text: 'Shift', value: 'shift' },
    { text: 'Component', value: 'components', align: "start"},
    { text: 'Ticket', value: 'ticket', sortable: false },
    { text: 'Time', value: 'time', sortable: false },
    { text: 'Name', value: 'username', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    const userId = this.$store.getters.id;
    await this.initialize(userId);
  }

  private async initialize(userId: string): Promise<void> {
    const audits: any = await this.devScrumRepository.getAuditsByUser(userId);
    const profile = await this.profileRepository.getBaseProfileDataByUserId(userId);
    this.audits = await Promise.all(audits.map(async (audit: any) => {
      const auditWithName = { ...audit };
      try {
        auditWithName.username = profile.fullName ? profile.fullName : `${profile.firstName} ${profile.lastName}`;
        auditWithName.date = new Date(auditWithName.date)
          .toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        return auditWithName
      } catch (e) {
        console.log('error', e);
      }
    }));
    this.loading = false;
  }

  private createAudit(): void {
    this.$router.push({ name: 'create_audit' });
  }

  private editAudit(audit: AuditInterface): void {
    this.$router.push({ name: 'audit_edit', params: { auditId: String(audit.id) } });
  }

  private deleteAudit(audit: AuditInterface): void {
    this.deleteAuditDialog = 'delete-audit-dialog';
    this.deleteAuditForDialog = audit;
  }

  private onAuditDeleted(deletedAuditId: number): void {
    this.audits = this.audits.filter(audit => audit.id !== deletedAuditId);
    this.deleteAuditForDialog = undefined;
  }
}
